if (!customElements.get('klaviyo-subscribe-form')) {
  class KlaviyoSubscribeForm extends HTMLElement {
    connectedCallback() {
      this.addEventListener('submit', this.onSubmit.bind(this));
      this.prefillFromQuery();
    }

    // The abandoned-checkout recruit email links here as ?email=<address> so the reader does not
    // have to retype what we already know. They still press Subscribe themselves — that click is
    // what keeps the opt-in genuine, which is the whole reason the email does not just subscribe
    // them server-side.
    //
    // Never overwrite a value already present: Shopify re-renders this input with form.email after
    // a failed post, and clobbering that would lose what the visitor typed.
    prefillFromQuery() {
      const input = this.querySelector('input[type="email"]');
      if (!input || input.value) return;

      let candidate;
      try {
        candidate = new URLSearchParams(window.location.search).get('email');
      } catch (error) {
        return;
      }
      // Reject anything that is not plausibly an address rather than prefilling the field with
      // junk the visitor then has to clear. Angle brackets and quotes are excluded too: assigning
      // to .value cannot inject markup, but there is no reason to seed a crafted link's payload
      // into a field the visitor is about to submit. This costs the prefill for the rare legal
      // address containing an apostrophe; that address still works, it just gets typed by hand.
      if (candidate && /^[^@\s<>"']+@[^@\s<>"']+\.[a-zA-Z]{2,}$/.test(candidate)) {
        input.value = candidate;
      }
    }

    onSubmit(event) {
      const companyId = this.dataset.klaviyoCompanyId;
      const listId = this.dataset.klaviyoListId;
      const emailInput = this.querySelector('input[type="email"]');
      const email = emailInput ? emailInput.value.trim() : '';

      if (!companyId || !listId || !email) return;

      // Fire alongside the native Shopify submit — do NOT preventDefault or call
      // form.submit(). Shopify's bot-protection injects a CAPTCHA token during the
      // native submit event; a programmatic re-submit skips that event, so Shopify
      // rejects the post with "Missing CAPTCHA token". keepalive lets this request
      // finish through the page reload (and Shopify's own async CAPTCHA step delays
      // that reload, giving the request time to land).
      fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`, {
        method: 'POST',
        keepalive: true,
        headers: {
          'content-type': 'application/json',
          revision: '2026-07-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: this.dataset.klaviyoSource || 'Theme Newsletter Form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    subscriptions: {
                      email: {
                        marketing: { consent: 'SUBSCRIBED' },
                      },
                    },
                  },
                },
              },
            },
            relationships: {
              list: {
                data: { type: 'list', id: listId },
              },
            },
          },
        }),
      }).catch((error) => {
        console.error('Klaviyo subscribe request failed', error);
      });
    }
  }

  customElements.define('klaviyo-subscribe-form', KlaviyoSubscribeForm);
}
